module.exports = __webpack_public_path__ + "assets/projects/zissel/laurels.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/zissel/laurels.mp4
// module id = 60
// module chunks = 0